import { PropsWithChildren } from "react";

import { CrudEditContext, ICrudEditContext, useCrudEdit } from "@ryde/redux";
import { EditFormMode, RequestBodyModel, RydeUiUnit } from "@ryde/shared";

interface ICrudEditContextWrapperProps extends PropsWithChildren {
  entity: RydeUiUnit;
  mode?: EditFormMode;
  idCopyFrom?: number;
  id?: number;
  duplicateReverseStations?: boolean;
}

export const CrudEditContextWrapper = <T extends RequestBodyModel>({
  entity,
  mode = EditFormMode.CrudRoute,
  idCopyFrom,
  id,
  duplicateReverseStations,
  children,
}: ICrudEditContextWrapperProps): JSX.Element => {
  const hookData = useCrudEdit<T>({
    entity,
    mode,
    idCopyFrom,
    id,
    duplicateReverseStations,
  });
  const contextData: ICrudEditContext<T> = {
    data: hookData,
    entity,
    mode,
    idCopyFrom,
    id,
  };

  return (
    <CrudEditContext.Provider value={contextData}>
      {children}
    </CrudEditContext.Provider>
  );
};
